import {DataFetcher} from '@aboutyou/data-fetcher';
import {FreeDeliverySection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/basket_mov.types';
import {AddItemResponseStatus_Success_Section} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import React from 'react';
import {useBasketRecommendations} from '../hooks/useBasketRecommendations';
import {AddToBasketSuccessFlyoutContentView} from './AddToBasketSuccessFlyoutContentView';

interface AddToBasketSuccessFlyoutContentProps {
  loadContent: boolean;
  productId: number;
  trackOriginClick: VoidFunction;
  ctas: React.ReactNode;
  freeDeliverySection?: FreeDeliverySection;
  statusSuccessSections: AddItemResponseStatus_Success_Section[];
}

export const AddToBasketSuccessFlyoutContent: React.FC<
  AddToBasketSuccessFlyoutContentProps
> = ({
  ctas,
  freeDeliverySection,
  loadContent,
  productId,
  trackOriginClick,
  statusSuccessSections,
}) => {
  const request = useBasketRecommendations({
    productId,
    requestEnabled: loadContent,
  });

  /* In case loadContent is false we need to still display the CTAs */
  if (!loadContent) {
    return <>{ctas}</>;
  }

  return (
    <DataFetcher
      request={request}
      View={AddToBasketSuccessFlyoutContentView}
      viewProps={{
        trackOriginClick,
        ctas,
        freeDeliverySection,
        statusSuccessSections,
      }}
      Error={null}
    />
  );
};
